import React from 'react';
import { Page, QuizConfig } from '../types';
import ElementRenderer from './ElementRenderer';

interface PageRendererProps {
  page: Page;
  config: QuizConfig;
  onOptionSelect?: (optionId: string | string[]) => void;
  selectedOption?: string | string[];
  multiple?: boolean;
  onNext?: () => void;
  showNextButton?: boolean;
  onFormChange?: (values: Record<string, any>) => void;
  formValues?: Record<string, any>;
  globalFormValues?: Record<string, any>;
  disableInterpolation?: boolean;
  invalidFieldIds?: string[];
  validationMessage?: string;
  onButtonAction?: (action: 'next' | 'redirect', redirectUrl?: string) => void;
  isRedirecting?: boolean;
  addUTMsToUrl?: (url: string) => string;
  priceCheckboxes?: Record<string, boolean>;
  onPriceCheckboxChange?: (itemId: string, checked: boolean) => void;
  coins?: number;
  onConfetti?: () => void;
  previewMode?: boolean;
  ignoreTimers?: boolean;
}

const PageRenderer: React.FC<PageRendererProps> = ({
  page,
  config,
  onOptionSelect,
  selectedOption,
  multiple = false,
  onNext,
  showNextButton = false,
  onFormChange,
  formValues,
  globalFormValues,
  disableInterpolation = true,
  invalidFieldIds,
  validationMessage,
  onButtonAction,
  isRedirecting = false,
  addUTMsToUrl,
  priceCheckboxes = {},
  onPriceCheckboxChange,
  coins = 0,
  onConfetti,
  previewMode = true,
  ignoreTimers = false,
}) => {
  const [localFormValues, setLocalFormValues] = React.useState<Record<string, any>>({});
  const handleFormChange = (vals: Record<string, any>) => {
    setLocalFormValues(vals);
    if (onFormChange) onFormChange(vals);
  };
  return (
    <div className="w-full">
      <div
        className="px-6 pt-2 pb-12"
        style={{
          backgroundColor: config.colors.background,
          borderRadius: config.borderRadius === 'none' ? 0 : config.borderRadius === 'light' ? '0.5rem' : config.borderRadius === 'medium' ? '0.75rem' : '1rem'
        }}
      >
        {/* Renderizar elementos da página */}
        {page.elements && page.elements.map((element) => {
          console.log('🟢 [PageRenderer] Renderizando elemento:', {
            id: element.id,
            type: element.type,
            index: page.elements.indexOf(element)
          });
          return (
            <ElementRenderer
              key={element.id}
              element={element}
              config={config}
              onOptionSelect={onOptionSelect}
              selectedOption={selectedOption}
              multiple={multiple}
              previewMode={previewMode}
              onNext={onNext}
              onFormChange={handleFormChange}
              formValues={formValues || localFormValues}
              globalFormValues={globalFormValues}
              disableInterpolation={disableInterpolation}
              invalidFieldIds={invalidFieldIds}
              validationMessage={validationMessage}
              onButtonAction={onButtonAction}
              isRedirecting={isRedirecting}
              addUTMsToUrl={addUTMsToUrl}
              priceCheckboxes={priceCheckboxes}
              onPriceCheckboxChange={onPriceCheckboxChange}
              coins={coins}
              onConfetti={onConfetti}
              ignoreTimers={ignoreTimers}
            />
          );
        })}

        {/* Botão de próximo e mensagem de validação */}
        {showNextButton && (
          <div className="mt-6">
            {Array.isArray(invalidFieldIds) && invalidFieldIds.length > 0 && (
              <div className="w-full mb-2 text-sm font-bold text-red-600" style={{ fontFamily: config.fontFamily }}>
                {validationMessage || 'Preencha os campos obrigatórios antes de continuar.'}
              </div>
            )}
            {onNext && (
              <div className="flex justify-center">
                <button
                  onClick={onNext}
                  className="w-full py-3 bg-sky-500 text-white font-semibold hover:bg-sky-600 transition-colors"
                  style={{
                    fontSize: config.fontSizes.option,
                    fontFamily: config.fontFamily,
                    borderRadius: config.borderRadius !== 'none' ? '0.5rem' : '0'
                  }}
                >
                  Continuar
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageRenderer;
